const theme = {
  primaryColor: '#0C3863',
  secondaryColor: '#7BA8CD',
  tertiaryColor: '#395491',
  white: '#fff',
  grey: '#ccc',
  warningColor: '#FFA745',
  confirmColor: '#49AA5B',
  cancelColor: '#D85A56',
  spacingS: '8px',
  spacingM: '16px',
  spacingL: '24px',
  spacingXL: '48px',
  borderRadius: '4px',
  fontSizeBase: '12px',
};

export default theme;
